import { css } from 'linaria';

export const reelItem = css`
  && {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    border: none;
    row-gap: 16px;
  }
`;

export const reelItemImage = css`
  display: block;
  width: 100%;
  height: auto;
  border-radius: var(--rounding-l);
`;
